import { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { postHttp } from 'src/api'
import { PATH_API, PATH_URL } from 'src/helpers'
import { SESSION_NAME_LOCAL, useAppContext } from 'src/helpers/app'
import { BoardItem, QuizType } from 'src/pages/shared'
import { QuizQuestionContext, SCREEN_QUIZ_QUESTION } from '../../contextAPI'
import { SegmentAction, segmentTracking } from 'src/helpers/segment'

export const usePinterestBoard = () => {
  const { setQuizScreen } = useContext(QuizQuestionContext)
  const { sessionID, setSessionID } = useAppContext()
  const [boards, setBoards] = useState<BoardItem[]>([])
  const history = useHistory()
  const [loading, setLoading] = useState(false)

  // When component mounts, ensure we have the session ID from localStorage
  useEffect(() => {
    const savedSessionId = localStorage.getItem(SESSION_NAME_LOCAL)
    if (savedSessionId && !sessionID) {
      console.log('[PinterestBoard] Restoring session ID from localStorage:', savedSessionId)
      setSessionID(savedSessionId)
    }
  }, [sessionID, setSessionID])

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleNext = () => {}
  const handleBack = () => {
    if (history.length > 1) {
      history.goBack()
    } else {
      history.push({
        pathname: PATH_URL.PINTEREST_LINK_YOUR_BOARD,
        search: new URLSearchParams({ quizType: QuizType.PINTEREST }).toString(),
      })
      setQuizScreen(SCREEN_QUIZ_QUESTION.PINTEREST_LINK_YOUR_BOARD)
    }
  }

  const handleOauthCode = async (code: string) => {
    if (!code) return

    setLoading(true)
    try {
      // Get session ID from context if available, fallback to localStorage
      const sessionId = sessionID || localStorage.getItem(SESSION_NAME_LOCAL)
      console.log('[Pinterest OAuth] Using session ID for API call:', sessionId)

      if (!sessionId) {
        console.error('[Pinterest OAuth] No session ID found!')
        return
      }

      const result = await postHttp(PATH_API.pinterestBoards(), {
        sessionId,
        code,
        redirectUri: `${window.location.origin}${window.location.pathname}`,
      })
      setBoards(result.data)

      // Track successful Pinterest authentication
      segmentTracking(SegmentAction.SQ_PINTEREST_AUTH_SUCCESS, {
        experienceType: 'pinterest',
        action: 'pinterest_auth_success',
        boardCount: result.data?.length || 0,
      })
    } catch (error) {
      console.log('[handleOauthCode] error: ', error)

      // Track failed Pinterest authentication
      segmentTracking(SegmentAction.SQ_PINTEREST_AUTH_ERROR, {
        experienceType: 'pinterest',
        action: 'pinterest_auth_error',
        error: error?.toString() || 'Unknown error',
      })
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    boards,
    handleNext,
    handleBack,
    handleOauthCode,
  }
}
